











































import { Component, Vue } from "vue-property-decorator";
import AppUsersSelect from "@/containers/AppUsersSelect.vue";
import { createAppUserTask } from "@/graphql/mutation/setAppUserTask";
import CSelect, { SelectOption } from "@/basics/selects/CSelect.vue";
import CButton from "@/basics/buttons/CButton.vue";
import DeleteModal from "@/components/modal/DeleteModal.vue";
import NoteBox from "@/basics/boxes/NoteBox.vue";
import SimpleTable from "@/basics/table/SimpleTable.vue";
import gql from "graphql-tag";
import { ROOM_ONE, RoomData, RoomVariables } from "@/graphql/query/room/one";
import EditableText, { SaveEventHandler } from "@/containers/EditableText.vue";
import { deleteRoom } from "@/graphql/mutation/deleteRoom";
import { updateRoom } from "@/graphql/mutation/updateRoom";
import { ALL_APP_USERS, AllAppUserData } from "@/graphql/query/appUser/all";
import formatDate from "@/lib/formatDate";

interface Group {
  id: string;
  name: string;
}

export interface AppUser {
  id: string;
  name: string;
  start: string;
  end: string;
  createdAt: string;
  expired: boolean;
  prePeriod: boolean;   
}

@Component({
  components: {
    AppUsersSelect,    
    CButton,
    CSelect,
DeleteModal,    
    NoteBox,
    SimpleTable,
    EditableText
  },
  apollo: {
    room: {
      query: ROOM_ONE,
      variables(): RoomVariables {
        const params = this.$apollo.vm.$route.params;
        return {
          roomId: params.roomId as string
        };
      }
    },
    appUsers: {
      query: ALL_APP_USERS,
      update(data: AllAppUserData): AppUser[] {
        return data.appUserFeed.appUsers.map(a => ({
          ...a,
          start: formatDate(new Date(a.start)),
          end: formatDate(new Date(a.end)),
          createdAt: formatDate(new Date(a.createdAt))          
        }));
      }
    }    
  }
})
export default class RoomDetails extends Vue {
  room: RoomData | null = null;

  selectedValue: string | null = null;
  selectedAppUser: string = "";
  deleted: boolean = false;
  deleteModal: boolean = false;

  get groupId(): string {
    return this.$route.params.groupId;
  }

  get loading(): boolean {
    return this.$apollo.loading;
  }

  get hasDevices(): boolean {
    return !!(
      this.room &&
      (this.room.mainLock || this.room.subLock || this.room.hub)
    );
  }

  get isRented(): boolean {
    return !!(this.room!.mode === "rented");
  }


  async addAppUser() {
    if(this.selectedAppUser === "") return alert("選択してください")
    try {
      const result = await createAppUserTask(
        this.$apollo,
        this.selectedAppUser,
        this.$apollo.vm.$route.params.buildingId,
        this.$apollo.vm.$route.params.roomId
      );
      await this.$apollo.provider.defaultClient.cache.reset();
      alert("保存しました");
      this.selectedAppUser = "";
    } catch (e) {
      alert("エラーが発生しました");
    }
  }

  async saveName(handler: SaveEventHandler) {
    handler(async (value: string) => {
      // 保存
      await updateRoom(this.$apollo, {
        roomId: this.$apollo.vm.$route.params.roomId,
        name: value
      });

      // クエリ再取得
      await this.$apollo.queries.room.refresh();
    });
  }

  async deleteRoom() {
    try {
      await deleteRoom(this.$apollo, this.$apollo.vm.$route.params.roomId);
      this.$router.push({ name: "building-details" });
    } catch {
      alert("削除に失敗しました");
      this.deleteModal = false;
    }
  }

}
